<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    window.onbeforeunload = () => false
  }
};
</script>

<style  rel="stylesheet/scss" lang="scss">
    @import "./style/common/reset.css";
    @import "./style/common/base";
    #app {
      width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue